import * as React from 'react';

const UploadSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="upload_svg__eds-icon--upload_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="upload_svg__eds-icon--upload_base"
            fill="#231F20"
            d="M16 16v1h5v4H3v-4h5v-1H2v6h20v-6z"
        />
        <path
            id="upload_svg__eds-icon--upload_arrow"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 2L6 7.8l.7.8 4.8-4.7V18h1V3.9l4.8 4.7.7-.7z"
        />
    </svg>
);

UploadSvg.displayName = 'UploadSvg';
export default UploadSvg;
